// extracted by mini-css-extract-plugin
module.exports = {"actions":"CommActions_actions__2dfoc","action":"CommActions_action__3Zicr"};